<div id="main-content">
  <h1 class="govuk-heading-xl">Sorry! An error has occurred</h1>
  <h2 class="govuk-heading-m">
    Please check your internet connection and try again
  </h2>
</div>
